
import React from 'react';
import { BrowserRouter as Router, Route, Routes as Routes1 } from 'react-router-dom'
import App from "./App";

export function RoutesMe() {
    return (
        <div>
            <Router>
                <Routes1>
                    <Route path="*" element={
                        <App />}>
                    </Route>
                </Routes1>
            </Router>
        </div>
    );

}